import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LmsButton, type ButtonSize, type ButtonVariant } from '@shared/ui'
import { LearningLessonShellFooter } from '@features/learning/shared/LearningLessonShell'
import { useLearningEnterContinue } from './learning-template-shortcuts'
import './learning-template-feedback.css'

export function LearningTemplateResultBar({
  continuePending = false,
  continuePendingLabel,
  embedded = false,
  finished,
  label,
  leadingIcon,
  onNext,
  size = 'md',
  trailingIcon,
  variant = 'accent',
}: {
  readonly continuePending?: boolean
  readonly continuePendingLabel?: ReactNode
  readonly embedded?: boolean
  readonly finished: boolean
  readonly label?: ReactNode
  readonly leadingIcon?: ReactNode
  readonly onNext: () => void
  readonly size?: ButtonSize
  readonly trailingIcon?: ReactNode
  readonly variant?: ButtonVariant
}) {
  const { t } = useTranslation('book')
  useLearningEnterContinue(onNext, !continuePending)

  return (
    <LearningLessonShellFooter
      className={`learningTemplateResultBar legacySelfStudyTemplateResultBar${
        embedded ? ' learningTemplateResultBarEmbedded' : ''
      }`}
    >
      <div className="learningTemplateResultBox legacySelfStudyTemplateResultBox">
        <LmsButton
          className="learningTemplateResultButton legacySelfStudyTemplateResultButton"
          disabled={continuePending}
          isLoading={continuePending}
          leadingIcon={leadingIcon}
          loadingLabel={continuePendingLabel ?? t(finished ? 'Saving' : 'Loading')}
          onClick={onNext}
          size={size}
          trailingIcon={trailingIcon}
          type="button"
          variant={variant}
        >
          {label ?? t(finished ? 'Finished' : 'Continue')}
        </LmsButton>
      </div>
    </LearningLessonShellFooter>
  )
}
